/* eslint-disable import/first */
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import { Button } from '@material-ui/core';

// import { selectDefaultAddress } = Slices.addressSlice;
// import { selectDesktop } = Slices.appSlice;
// import { selectStoreEntities } = Slices.storeSlice;
import NoAddress from './NoAddress';
import css from './index.module.scss';
import { OrderSummaryStore } from '../Icons';
import { FormattedMessage, useIntl } from 'react-intl';

const { selectDesktop } = Slices.appSlice;
const { selectStoreEntities } = Slices.storeSlice;
const { selectDefaultAddress } = Slices.addressSlice;
// const { selectCountryValidations } = Slices.configSlice;
// const { selectCurrentCountry } = Slices.profileSlice;

const AddressWidget = ({ urlPathToMode }) => {
  const address = useSelector(selectDefaultAddress);
  const location = useLocation();
  const isDesktop = useSelector(selectDesktop);
  const storeList = useSelector(selectStoreEntities);
  const auth = useSelector((state) => state.auth);
  // const country = useSelector(selectCurrentCountry);
  // const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const navigate = useNavigate();
  const [selectedStore, setSelectedStore] = React.useState({});
  const intl = useIntl();
  const heading = {
    STORE: intl.formatMessage({ id: 'checkout_pickup_store_detail' }),
    DELIVERY: intl.formatMessage({ id: 'order_delivery' }),
    CARHOP: intl.formatMessage({ id: 'checkout_carhopDetails' }),
    DINEIN: intl.formatMessage({ id: 'checkout_dineinDetails' }),
    DRIVETHRU: intl.formatMessage({ id: 'checkout_driveThruDetails' }),
  };
  const modeRoute = {
    DELIVERY: 'addresses',
    STORE: 'pickup',
    CARHOP: 'carhop',
    DINEIN: 'dinein',
    DRIVETHRU: 'drivethru',
  };

  const handleChangeAddress = (e) => {
    e.preventDefault();
    if (isDesktop) {
      navigate(`${location.pathname}?modal=${address.addressSubType.toLowerCase()}`);
    } else {
      navigate(`${modeRoute[address.addressSubType]}/select`);
    }
  };
  const addressString = `address_${intl.locale}`;

  // useEffect(() => {
  //   const stroe = storeList?.ids?.forEach((val) => {
  //     const storeDetail = storeList.entities[val];
  //     if (storeDetail.storeId === address?.storeId) {
  //       setSelectedStore(storeDetail);
  //     }
  //   });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    Object.values(storeList || {}).every((val) => {
      if (val.storeId === address?.storeId) {
        setSelectedStore(val);
        return false;
      }
      return true;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!Object.entries(address).length) {
    return <NoAddress urlPathToMode={urlPathToMode} navigate={navigate} location={location} />;
  }
  return (
    <div className={css.root}>
      <div className={css.addressBox}>
        <div className={css.addressTitle}>
          <h4>{heading[address.addressSubType]}</h4>
          <Button
            variant={'outlined'}
            color={'secondary'}
            className={css.buttonAddress}
            onClick={handleChangeAddress}
          >
            <FormattedMessage id="checkout_change" defaultMessage="Change" />
          </Button>
        </div>

        <div className={css.addressList}>
          <div className={css.houseIcon}>
            <OrderSummaryStore />
          </div>
          <div className={css.addressListItem}>
            <div className={css.addressLable}>
              {address?.addressType !== 'DELIVERY' ? (
                ''
              ) : (
                <div className={css.button}>{address.tag}</div>
              )}
              <div className={css.addressText}>
                {address?.flatNum > 0 && (
                  <>
                    {address.flatNum}
                    {', '}
                  </>
                )}
                {address?.bldgName}
              </div>
            </div>

            <div className={css.addressDescription}>
              {address?.addressType !== 'DELIVERY'
                ? selectedStore?.[addressString]
                : address?.description}
            </div>
          </div>
        </div>

        {/* <div className={css.contactLess}>
          <FormControlLabel
            control={<Checkbox defaultChecked />}
            label="100% Contactless Delivery"
          />
        </div> */}
        {/* <div className={css.cooking}>
          <h4>Special Instructions (Optional)</h4>
          <input></input>
        </div> */}
      </div>
    </div>
  );
};

export default AddressWidget;
